import { styled } from '@mui/material';
import { CoreBox } from '@youscience/core';
import { propsFilter } from '@utils/propsFilter';

export const StyledChecklist = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'stretch',
  alignItems: 'flex-start',
  gap: '0.5rem',
  borderRadius: '9999px',
}));

export const StyledChecklistTitle = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  gap: '1rem',
  alignItems: 'center',

  '& > h6:first-of-type': {
    fontSize: '1.125rem',
  },

  [theme.breakpoints.down('md')]: {
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));

export const StyledChecklistItemGroup = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '0.5rem',
}));

export const StyledChecklistItem = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  '& > div:last-of-type': {
    marginLeft: '0.5rem',
  },
}));

export const StyledChecklistButtonGroup = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '0.5rem',
}));

export const StyledChecklistIconButton = styled(CoreBox, {
  shouldForwardProp: propsFilter(['isDisable']),
})<{ isDisable?: boolean }>(({ isDisable, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '40px',
  background: isDisable ? theme.palette.grey[100] : 'none',

  '&:hover': {
    cursor: 'pointer',
    background: theme.palette.grey[100],
  },
}));
